export default {
  'ropsten': 3,
  'reqinkeby': 4,
  'kovan': 42,
  'local': 5777,
}
